/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'course-center': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M220.16 861.867h-85.333c-28.16 0-51.2-23.04-51.2-51.2V213.333c0-28.16 23.04-51.2 51.2-51.2h85.333c28.16 0 51.2 23.04 51.2 51.2v597.334c0 28.16-23.04 51.2-51.2 51.2zm238.933 0H373.76c-28.16 0-51.2-23.04-51.2-51.2V213.333c0-28.16 23.04-51.2 51.2-51.2h85.333c28.16 0 51.2 23.04 51.2 51.2v597.334c0 28.16-23.04 51.2-51.2 51.2zm445.014-32.854l-80.64 27.734c-26.88 9.386-55.894-5.12-65.28-31.574l-194.56-564.906c-9.387-26.88 5.12-55.894 31.573-65.28l80.64-27.734c26.88-9.386 55.893 5.12 65.28 31.574l194.56 564.906c9.387 26.88-4.693 55.894-31.573 65.28z" _fill="#cdcdcd"/>'
  }
})
